import { useCommentsApi } from '@api/tutor-kanban/comments.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const tutorId = to.params.id as string

  void useCommentsApi({ tutorId })
})
